<template>
  <b-col>
    <template v-if="!hideName">
      <p class="mb-0"><b>{{name || 'Job History'}}</b></p>
    </template>
    <p
      v-for="({ jobTitle, companyTitle, startDate, endDate }) in (value || [])"
      :key="`${jobTitle}-${companyTitle}`"
      style="line-height: 1.2rem"
    >
      <span>{{ jobTitle }}{{ companyTitle ? ` (at ${companyTitle})` : '' }}</span>
      <template v-if="startDate">
        <br><span class="text-muted">{{ formatDate(startDate, 'MMM YYYY') }} - {{ endDate ? formatDate(endDate, 'MMM YYYY') : '' }}</span>
      </template>
    </p>
  </b-col>
</template>

<script>
import formatDate from 'date-fns/format';

export default {
  name: 'JobHistoryShow',
  props: {
    name: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate,
  }
};
</script>


// WEBPACK FOOTER //
// src/components/profile/JobHistoryShow.vue